import { PhoneCall, Clock } from "@phosphor-icons/react";
import { BUSINESS } from "../data/constants";

export default function FinalCTABanner({
  headline = "Don't Wait. Call Now and Get a Tech to Your Door Fast.",
  subtext = "Available 24/7 across the Greater Toronto Area.",
  testId = "final-cta-banner",
}) {
  return (
    <section
      data-testid={testId}
      className="relative overflow-hidden bg-[#FF6B00] text-white"
    >
      <div className="absolute inset-0 grain" aria-hidden />
      <div className="relative mx-auto max-w-6xl px-4 md:px-6 py-14 md:py-20 text-center">
        <h2 className="font-display font-black text-white text-3xl sm:text-4xl md:text-5xl lg:text-6xl tracking-tight max-w-4xl mx-auto">
          {headline}
        </h2>
        <a
          href={BUSINESS.phoneHref}
          data-testid={`${testId}-call-button`}
          className="mt-8 inline-flex items-center justify-center gap-3 rounded-sm bg-white text-[#1B2A4A] font-display font-black px-8 py-5 text-xl md:text-3xl hover:bg-[#1B2A4A] hover:text-white transition-all hover:-translate-y-1 shadow-xl"
        >
          <PhoneCall size={28} weight="fill" className="text-[#FF6B00]" />
          <span className="phone-number">{BUSINESS.phone}</span>
        </a>
        <div className="mt-6 inline-flex items-center gap-2 text-white/90 text-sm font-bold font-display uppercase tracking-widest">
          <Clock size={18} weight="fill" />
          {subtext}
        </div>
      </div>
    </section>
  );
}
